// FAQ copy, shared by the homepage FAQ section (Splash.js) and the
// standalone FAQs page (pages/FAQs/FAQs.js) so the two never drift apart.
// Text is taken verbatim from the existing FAQs page — no new copy.

export const FAQS = [
  {
    q: "Do I need to make repairs before selling my house?",
    a: "No. CarpHomes buys houses as-is, so you don’t need to make repairs, clean everything out, or spend money getting the property ready to sell. We’ll take a look at the home in its current condition and make our offer from there.",
  },
  {
    q: "How quickly can CarpHomes buy my house?",
    a: "We can often close much faster than a traditional home sale. Every situation is different, so we’ll work with you to choose a closing date that makes sense for your timeline.",
  },
  {
    q: "Are there any fees or commissions when I sell to CarpHomes?",
    a: "When CarpHomes buys your property directly, there are no real estate agent commissions. We’ll clearly explain the numbers and terms of our offer upfront so you know what to expect before making a decision.",
  },
  {
    q: "What types of houses does CarpHomes buy?",
    a: "We buy homes in all kinds of situations and conditions—from well-maintained houses to properties that need significant repairs or updates. We also work with inherited properties, rentals, vacant homes, and houses that may be difficult to sell traditionally.",
  },
  {
    q: "Am I obligated to sell after requesting an offer?",
    a: "No. Requesting an offer from CarpHomes does not obligate you to sell your house. We’ll evaluate the property, explain our offer, and give you the opportunity to decide whether selling to us makes sense for you.",
  },
  {
    q: "Will I get to meet someone from CarpHomes in person?",
    a: "Yes! We believe you should know exactly who you’re doing business with. A local CarpHomes team member will meet you in person and see your property firsthand before we purchase your home.\n\nWe recommend being cautious of any company or investor willing to buy your house without ever seeing the property or meeting you in person. Selling a home is a major transaction, and you should feel confident that you’re working with a legitimate, local buyer who understands your property and will stand behind their offer.",
  },
];

export default FAQS;
